import {Pipe, PipeTransform} from '@angular/core';
import {LoggerService} from '../../hbs-services';

@Pipe({
    name: 'nLabel'
})
export class NumberingLabelPipe implements PipeTransform {

    constructor(private logger: LoggerService) {
    }

    /**
     *  Note: function may return unexpected label when index is too large.
     *  Good labels are between "65": "A" and "90": "Z"
     * @param labelTypeCode - question's choicesLabelTypeCode or subquestLabelTypeCode
     * @param args
     * @returns {any}
     */
    transform(labelTypeCode: string, args: any[]): any {
        // const choicesLabelTypeCode: string = q.choicesLabelTypeCode;
        const index = Number(args);
        let label = '';

        // "65": "A", "90": "Z"

        if (labelTypeCode === 'A') {
            label = String.fromCharCode(65/*A*/ + index);
        } else if (labelTypeCode === '#') {
            label = String(index + 1);
        }

        return label;
    }
}
